export default __webpack_public_path__ + "media/src/assets/images/LocIconMarker-ce42925190f4bd8341a98228f2417776.svg";